"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SplitNavItem: function() {
        return _index.SplitNavItem;
    },
    renderSplitNavItem_unstable: function() {
        return _index.renderSplitNavItem_unstable;
    },
    splitNavItemClassNames: function() {
        return _index.splitNavItemClassNames;
    },
    useSplitNavItemStyles_unstable: function() {
        return _index.useSplitNavItemStyles_unstable;
    },
    useSplitNavItem_unstable: function() {
        return _index.useSplitNavItem_unstable;
    }
});
const _index = require("./components/SplitNavItem/index");
